import React from 'react';
import { Clock3, Play, Square, SlidersHorizontal } from 'lucide-react';

const PollControls = ({
  questionType,
  setQuestionType,
  isPollActive,
  pollTimer,
  startPoll,
  stopPoll,
  showPromptModal,
  disablePollButton,
  quizFormat,
  optionCount,
  setOptionCount,
}) => {
  return (
    <div
      className="rounded-lg border p-4"
      style={{
        backgroundColor: 'var(--card-bg)',
        borderColor: 'var(--border-color)',
        boxShadow: 'var(--shadow-sm)',
      }}
    >
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em]" style={{ color: 'var(--primary-color)' }}>
            Poll setup
          </p>
          <h4 className="mt-1 text-lg font-semibold" style={{ color: 'var(--text-color)' }}>
            Question controls
          </h4>
        </div>
        <div
          className="rounded-lg border p-2"
          style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)', color: 'var(--primary-color)' }}
        >
          <SlidersHorizontal size={18} aria-hidden="true" />
        </div>
      </div>

      <form className="space-y-4">
        <div>
          <label className="mb-1 block text-sm font-semibold" style={{ color: 'var(--text-color)' }}>
            Question Type
          </label>
          <select
            value={questionType}
            onChange={(e) => setQuestionType(e.target.value)}
            disabled={isPollActive || showPromptModal}
            className="w-full rounded-lg border px-3 py-2.5 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
            style={{
              backgroundColor: 'var(--alt-bg)',
              color: 'var(--text-color)',
              borderColor: 'var(--border-color)',
            }}
          >
            <option value="multiple_choice">Multiple Choice</option>
            <option value="multiple_multiple_choice">Multiple Answers</option>
            <option value="yes_no">Yes/No</option>
            <option value="short_input">Short Input</option>
          </select>
        </div>

        {/* only show when quizFormat=dynamic AND asking a multiple‐choice question */}
        {quizFormat === 'dynamic' &&
          (questionType === 'multiple_choice' || questionType === 'multiple_multiple_choice') && (
            <div>
              <label className="mb-1 block text-sm font-semibold" style={{ color: 'var(--text-color)' }}>
                Number of Options
              </label>
              <select
                value={optionCount}
                onChange={e => setOptionCount(Number(e.target.value))}
                disabled={isPollActive || showPromptModal}
                className="w-full rounded-lg border px-3 py-2.5 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                style={{ backgroundColor: 'var(--alt-bg)', color: 'var(--text-color)', borderColor: 'var(--border-color)' }}
              >
                {Array.from({ length: 9 }, (_, i) => i + 1).map(n => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>
          )}



        <button
          type="button"
          className="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-semibold text-white transition-all duration-200"
          style={{
            backgroundColor: disablePollButton ? 'grey' : 'var(--primary-color)',
            boxShadow: disablePollButton ? 'none' : 'var(--shadow-primary)',
            cursor: disablePollButton ? 'not-allowed' : 'pointer',
          }}
          onMouseOver={(e) => {
            if (!disablePollButton) e.currentTarget.style.backgroundColor = 'var(--hover-color)';
          }}
          onMouseOut={(e) => {
            if (!disablePollButton) e.currentTarget.style.backgroundColor = 'var(--primary-color)';
          }}
          onClick={(e) => {
            if (disablePollButton) {
              alert("Selected screen not available. Please select a valid window.");
            } else {
              isPollActive ? stopPoll(e) : startPoll(e);
            }
          }}
          title={disablePollButton ? "Selected screen not available. Please select a valid window." : ""}
        >
          {isPollActive ? <Square size={16} aria-hidden="true" /> : <Play size={16} aria-hidden="true" />}
          {isPollActive ? 'Stop Poll' : 'Start Poll'}
        </button>
        <div
          className="flex items-center justify-between rounded-lg border px-3 py-2 text-sm"
          style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)', color: 'var(--text-color)' }}
        >
          <span className="flex items-center gap-2 font-medium">
            <Clock3 size={15} aria-hidden="true" />
            Time elapsed
          </span>
          <span className="font-mono font-semibold">{isPollActive ? pollTimer : 0}s</span>
        </div>
      </form>
    </div>
  );
};

export default PollControls;
